module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-034818cb0bc284ebabed18c04dbcc272.png";